import { render } from "./ProjectAdminAutocomplete.vue?vue&type=template&id=88f017a4&scoped=true"
import script from "./ProjectAdminAutocomplete.vue?vue&type=script&lang=js"
export * from "./ProjectAdminAutocomplete.vue?vue&type=script&lang=js"

import "./ProjectAdminAutocomplete.vue?vue&type=style&index=0&id=88f017a4&lang=scss&scoped=true"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f017a4"]])

export default __exports__